import { useEffect, useState } from "react";

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Небольшая задержка для запуска анимации после полной загрузки
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Структурированные данные для SEO
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Лесная Усадьба — Фотолокация в стиле фармхаус в Солнечногорском районе",
      description:
        "Уютная фотолокация в стиле фармхаус для атмосферных фотосессий в любое время года. Расположена в Солнечногорском районе Московской области.",
      url: "https://fotodacha.ru/",
      image: "https://fotodacha.ru/image-main.jpg",
      keywords:
        "фотолокация, фотосессия, Подмосковье, Солнечногорский район, Московская область, farmhouse, cottagecore, аренда локации, фотосъемка, фотодача, фотозона",
      potentialAction: {
        "@type": "ReadAction",
        target: "https://fotodacha.ru/#about",
      },
    };

    // Добавляем структурированные данные
    let scriptTag = document.querySelector("#hero-structured-data");
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.id = "hero-structured-data";
      scriptTag.type = "application/ld+json";
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(structuredData);

    return () => {
      clearTimeout(timer);
      if (scriptTag) {
        document.head.removeChild(scriptTag);
      }
    };
  }, []);

  return (
    <section id="home" className="hero">
      <div className="hero-bg">
        <img
          src="/image-main.jpg"
          alt="Лесная Усадьба - фотолокация в стиле фармхаус в Солнечногорском районе Подмосковья"
          className="w-full h-full object-cover"
          width="1920"
          height="1080"
          fetchpriority="high"
        />
      </div>

      <div className="hero-container container relative z-10 h-full flex items-center justify-center">
        <div
          className={`hero-content ${
            isVisible ? "fade-in-up visible" : "fade-in-up"
          }`}
        >
          <h1>Лесная Усадьба</h1>
          <p>
            Уютная фотолокация в стиле фармхаус для атмосферных фотосессий в
            любое время года
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            {/* <a
              href="#booking"
              className="btn btn-primary rounded-full px-8 py-3 text-center"
            >
              Забронировать
            </a> */}
            <a
              href="#about"
              className="btn btn-outline rounded-full px-8 py-3 text-center border-2 border-white text-white hover:bg-white hover:text-olive"
              aria-label="Узнать больше о фотолокации Лесная Усадьба в Солнечногорском районе"
            >
              Узнать больше
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 flex justify-center">
        <a
          href="#about"
          className="flex items-center justify-center w-12 h-12 text-white transition-all duration-300 border border-white rounded-full animate-bounce hover:bg-white/20"
          aria-label="Прокрутить вниз к разделу О нашей усадьбе"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Hero;
